export enum BundleStatus {
  new = 'new',
  winner = 'winner',
  validationFail = 'validationFail',
  lateness = 'lateness',
  overBidded = 'overBidded',
}
